import React from 'react'
import { SignInButton, SignUpButton } from '@clerk/clerk-react'

const SignInPage: React.FC = () => {
  return (
    <div className="signin-page">
      <div className="signin-container glassmorphism">
        <div className="signin-header">
          <h1 className="signin-title text-gradient">Voyager Admin</h1>
          <p className="signin-subtitle">
            Administrative access to platform data and file management
          </p>
        </div>
        
        <div className="signin-content">
          <p className="signin-description">
            Sign in with your authorized administrator account to access the admin dashboard.
          </p>
          
          <div className="signin-actions">
            <SignInButton mode="modal">
              <button className="btn btn-primary signin-btn">
                Sign In to Admin
              </button>
            </SignInButton>
            
            <SignUpButton mode="modal">
              <button className="btn btn-secondary signup-btn">
                Request Admin Access
              </button>
            </SignUpButton>
          </div>
        </div>
        
        <div className="signin-footer">
          <p className="signin-note">
            ⚠️ This is a restricted administrative interface. 
            Only authorized personnel should access this system.
          </p>
        </div>
      </div>
    </div>
  )
}

export default SignInPage